<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Workflow</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Workflow</h6>
    </table>


    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="container-fluid mt-4">

    <div class="row align-items-center">

        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="mat-table-pedidos">
                <table mat-table matTableResponsive [dataSource]="dataSource" matSort #matSort="matSort"
                    matSortActive="fechaCreacion" matSortDirection="asc">



                    <ng-container matColumnDef="fechaCreacion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.FechaCreacion}}
                        </th>
                        <td mat-cell *matCellDef="let log">
                            {{log.fechaCreacion | date:'dd/MM/yyyy HH:mm'}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>
                    <ng-container matColumnDef="estadoAnterior">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.EstadoAnterior}}
                        </th>
                        <td mat-cell *matCellDef="let log">
                            {{log.estadoAnterior}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>

                    <ng-container matColumnDef="estadoNuevo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.EstadoNuevo}}
                        </th>
                        <td mat-cell *matCellDef="let log">
                            {{log.estadoNuevo}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>


                    <ng-container matColumnDef="nombreApellido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.NombreApellido}}
                        </th>
                        <td mat-cell *matCellDef="let log">
                            {{log.nombreApellido}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>

                    <ng-container matColumnDef="cargo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Cargo}}
                        </th>
                        <td mat-cell *matCellDef="let log">
                            {{log.cargo}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>

                    <ng-container matColumnDef="comentario">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Comentario}}
                        </th>
                        <td mat-cell *matCellDef="let log">
                            {{log.comentario}} </td>
                        <td mat-footer-cell *matFooterCellDef> </td>
                    </ng-container>



                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let log; columns: displayedColumns;">
                    </tr>
                  
                    <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                            {{Etiquetas.SinRegistros}}
                        </td>
                    </tr>
                </table>

                <mat-paginator #matPaginator="matPaginator" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
    </div>
</div>